"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LegendItem = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: 8px;\n  padding: 4px;\n  vertical-align: middle;\n  cursor: default;\n  ", "\n"])), function (props) {
  return !props.on && "\n    color: #ccc;\n  ";
});

var LegendRectangle = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  border: 1px rgba(0, 0, 0, 0.2) solid;\n  display: inline-block;\n  margin-right: 4px;\n  vertical-align: middle;\n  background: ", ";\n"])), function (props) {
  return props.background;
});

var VerticallyAlignedSpan = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  vertical-align: middle;\n"])));

var DataSeriesHeatmapLegendBox = function DataSeriesHeatmapLegendBox(props) {
  return /*#__PURE__*/_react["default"].createElement(LegendItem, {
    on: props.on
  }, /*#__PURE__*/_react["default"].createElement(LegendRectangle, {
    background: props.colour,
    on: props.on
  }), /*#__PURE__*/_react["default"].createElement(VerticallyAlignedSpan, null, props.name));
};

DataSeriesHeatmapLegendBox.propTypes = {
  name: _propTypes["default"].string.isRequired,
  colour: _propTypes["default"].string.isRequired,
  on: _propTypes["default"].bool.isRequired
};

var HeatmapLegendContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: #606060;\n  border: 0 solid olive;\n  text-align: right;\n"])));

var InfoIcon = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ::before {\n    font-family: 'EBI-Generic', 'sans-serif';\n    font-size: 150%;\n    color: #7e7e7e;\n    content: attr(data-icon);\n    margin: 0 0 0 0;\n  }\n"])));

var ExperimentIconDiv = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n  font-size: 16px;\n  height: 20px;\n  width: 20px;\n  text-align: center;\n  padding-left: 1px;\n  vertical-align: middle;\n  margin-right: 6px;\n  margin-left: 10px;\n  opacity: 0.4;\n  display: inline-block;\n"])), function (props) {
  return props.background;
}, function (props) {
  return props.color;
});

var DataSeriesHeatmapLegend = function DataSeriesHeatmapLegend(props) {
  return /*#__PURE__*/_react["default"].createElement(HeatmapLegendContainer, null, /*#__PURE__*/_react["default"].createElement(ExperimentIconDiv, {
    background: "green",
    color: "white"
  }, "P"), "Proteomics", /*#__PURE__*/_react["default"].createElement(ExperimentIconDiv, {
    background: "orangered",
    color: "white"
  }, "T"), "Transcriptomics", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(LegendItem, null, /*#__PURE__*/_react["default"].createElement(InfoIcon, {
    "data-icon": "i",
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    title: props.title
  })), props.legendItems.map(function (legendItemProps) {
    return /*#__PURE__*/_react["default"].createElement(DataSeriesHeatmapLegendBox, legendItemProps);
  }), /*#__PURE__*/_react["default"].createElement(DataSeriesHeatmapLegendBox, {
    key: props.missingValueLabel,
    name: props.missingValueLabel,
    colour: props.missingValueColour,
    on: true
  }));
};

DataSeriesHeatmapLegend.propTypes = {
  legendItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(DataSeriesHeatmapLegendBox.propTypes)).isRequired,
  title: _propTypes["default"].string,
  missingValueColour: _propTypes["default"].string,
  missingValueLabel: _propTypes["default"].string
};
DataSeriesHeatmapLegend.defaultProps = {
  title: "Baseline expression levels in RNA-seq experiments are in FPKM or TPM. " + "Low: 0.5-10, Medium: 11-1,000, " + "High: >1,000. " + "Proteomics expression levels are mapped to low, medium, high per experiment basis.",
  missingValueColour: "white",
  missingValueLabel: "No data available"
};
var _default = DataSeriesHeatmapLegend;
exports["default"] = _default;